export default "__VITE_ASSET__8UIJuwzu__"